const EQUALS_OPERATOR = '==';
const NOT_EQUALS_OPERATOR = '!=';
const IN_OPERATOR = 'in';

export class FirestoreQuery {
  static equals(key, value) {
    return new FirestoreCriterion(key, EQUALS_OPERATOR, value);
  }

  static notEquals(key, value) {
    return new FirestoreCriterion(key, NOT_EQUALS_OPERATOR, value);
  }


  static in(key, values) {
    return new FirestoreCriterion(key, IN_OPERATOR, values);
  }
}

export class FirestoreCriterion {
  constructor(key, operator, value) {
    this.key = key;
    this.operator = operator;
    this.value = value;
  }

  toString() {
    return `${this.key} ${this.operator} ${this.value}`;
  }
}

export class FirestoreOrderBy {
  static ascending(field) {
    return new FirestoreOrderBy(field, 'asc');
  }

  static descending(field) {
    return new FirestoreOrderBy(field, 'desc');
  }

  constructor(field, order) {
    this.field = field;
    this.order = order;
  }
}
